import * as React from "react";
import { useParams } from "react-router-dom";

import KeyForm from "../../../components/Forms/Keys/FlowForm/FlowForm";

export default () => {
    const { id } = useParams();
  return <KeyForm method="PATCH" id={id}/>;
};
